import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';
import { User } from '../types/User';

const URL = '/v2/admin/job-board-blocks';

class JobBoardBlockService {
  static block(
    userId: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<User>> {
    return axios.post(URL, { userId }, config);
  }
}

export { JobBoardBlockService };
